import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  UpdateLeadWorkflowMutation,
  UpdateLeadWorkflowMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const UPDATE_LEAD_WORKFLOW_MUTATION = graphql(`
  mutation updateLeadWorkflow(
    $updateWorkflow: UpdateWorkflowInput!
    $stageFilterRequest: WorkflowStageSearchRequest
  ) {
    updateLeadWorkflow(updateWorkflow: $updateWorkflow) {
      id
      isDefault
      transitions {
        id
        group
        order
        stage {
          id
          name
          color
          iconColor
          iconName
          leadCount(WorkflowStageSearchRequest: $stageFilterRequest)
        }
      }
    }
  }
`);

export function useUpdateLeadWorkflow(
  options: UseMutationOptions<
    UpdateLeadWorkflowMutation,
    unknown,
    UpdateLeadWorkflowMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { data, ...rest } = useGraphQlMutation(UPDATE_LEAD_WORKFLOW_MUTATION, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: ["leadWorkflow"] });
      await queryClient.invalidateQueries({ queryKey: ["leads"] });
      await queryClient.invalidateQueries({ queryKey: ["lead"] });

      options.onSuccess?.(data, variables, context);
    },
  });

  return { data, ...rest };
}
